import { Button, Flex, HStack, Spinner, VStack } from '@chakra-ui/react';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { UI } from 'src/apps/invest/common/shells/UI';
import { useActivityViewModel } from '../models/ActivityViewModel';
import { ActivityRecord } from '../types';
import { RewardCard } from './RewardCardView';
import { TradeCard } from './TradeCardView';
import { TransactionCard } from './TransactionCard';

export const ActivityPage: React.FC = () => {
  const model = useActivityViewModel();
  return (
    <UI>
      {model.isLoading ? (
        <VStack>
          <Spinner color="blue.500" />
        </VStack>
      ) : (
        <Flex direction={'column'} gap="20px">
          <HStack w="full" justify={'space-between'}>
            <TextBlock weight="bold" mb={'24px'} fontSize="40px">
              Activity
            </TextBlock>
            <Button
              variant="ghost"
              onClick={() => (model.sortByDateDir === 'desc' ? model.sortByDate('asc') : model.sortByDate('desc'))}
              size="sm">
              {model.sortByDateDir === 'desc' ? '↓' : '↑'}
            </Button>
          </HStack>
          <VStack w="full" gap="10px">
            {model.records.length === 0 && <TextBlock>You have no activity</TextBlock>}
            {model.records.map((record: ActivityRecord, i: number) => {
              switch (record.type) {
                case 'Transaction':
                  return <TransactionCard key={i} record={record} />;
                case 'Trade':
                  return <TradeCard key={i} record={record} />;
                case 'Reward':
                  return <RewardCard key={i} record={record} />;
                default:
                  return null;
              }
            })}
          </VStack>
        </Flex>
      )}
    </UI>
  );
};
